<template>
  <div>
    <h2>
      Request - 
      <span style="text-transform: capitalize">
        {{ request.request_type }}
      </span>
      <small>
        #{{ request.id }}
      </small>
    </h2>
    <!-- request date & helper code -->
    <v-row>
      <v-col cols="4">
        <p>
          <b>Request Date:</b>
          {{ issue_date }}
        </p>
      </v-col>
      <v-col cols="4">
        <p
          v-show="request.request_helper_code"
        >
          <b>Request Helper Code:</b>
          {{ request.request_helper_code }}
        </p>
      </v-col>
    </v-row>
    <hr>
    <!-- end request date & helper code -->
    <!-- contact -->
    <h3>Contact</h3>
    <v-row>
      <v-col cols="4">
        <p>
          <b>Contact name:</b>
          {{ request.contact_name }}
        </p>
      </v-col>
      <v-col cols="4">
        <p>
          <b>Phone number:</b>
          {{ request.phone_number }}
        </p>
      </v-col>
      <v-col cols="4">
        <p>
          <b>Email:</b>
          {{ request.email }}
        </p>
      </v-col>
      <v-col cols="4">
        <p>
          <b>Line ID:</b>
          {{ request.line_id }}
        </p>
      </v-col>
    </v-row>
    <hr>
    <!-- end contact -->
    <!-- location -->
    <h3>Location</h3>
    <v-row>
      <v-col cols="4">
        <p>
          <b>Province:</b>
          {{ request.province_name_en }}
        </p>
      </v-col>
      <v-col cols="4">
        <p>
          <b>District:</b>
          {{ request.district_name_en }}
        </p>
      </v-col>
      <v-col cols="4">
        <p>
          <b>Sub-district:</b>
          {{ request.sub_district_name_en }}
        </p>
      </v-col>
      <v-col cols="4" v-show="request.request_type == 'maid'">
        <p>
          <b>Type of Building:</b>
          {{ request.type_of_building }}
        </p>
      </v-col>
      <v-col cols="4" v-show="request.request_type == 'maid'">
        <p>
          <b>Floor:</b>
          {{ request.floor }}
        </p>
      </v-col>
      <v-col cols="12">
        <p>
          <b>Address detail:</b>
          {{ request.address_detail }}
        </p>
      </v-col>
    </v-row>
    <hr>
    <!-- end location -->
    <!-- job detail -->
    <h3>Job Detail</h3>
    <v-row
      v-show="request.request_type == 'maid'"
    >
      <v-col cols="4">
        <p>
          <b>Employer Nationality:</b>
          {{ request.employer_nationality }}
        </p>
      </v-col>
      <v-col cols="4">
        <table>
          <tbody>
            <tr>
              <td>
                <b>Type of Worker:</b>
              </td>
              <td>
                <p
                  v-for="(item, i) in request.type_of_worker"
                  :key="i"
                >
                  {{ item }}
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </v-col>
      <v-col cols="4">
        <p>
          <b>Work Days:</b>
        </p>
        <p
          v-for="(item, i) in request.work_day"
          :key="i"
        >
          {{ item }}
          <span
            v-show="request.work_day.includes('other')"
          >
            ({{ request.work_day_other }})
          </span>
        </p>
      </v-col>
      <v-col cols="4">
        <p>
          <b>Work Time:</b>
          {{ request.work_time }}
        </p>
      </v-col>
      <v-col cols="4">
        <p>
          <b>Type of Work Schedule:</b>
          {{ request.work_type }}
        </p>
      </v-col>
      <v-col cols="4">
        <p>
          <b>Helper Nationality:</b>
        </p>
        <p
          v-for="(item, i) in request.helper_nationality"
          :key="i"
        >
          {{ item }}
        </p>
      </v-col>
      <v-col cols="4">
        <p>
          <b>Expected Language from Helper:</b>
        </p>
        <p
          v-for="(item, i) in request.expect_language"
          :key="i"
        >
          {{ item }}
          <span
            v-show="request.expect_language.includes('Other')"
          >
            ({{ request.work_day_other }})
          </span>
        </p>
      </v-col>
      <v-col cols="4">
        <p>
          <b>Required Helper to Cook:</b>
          {{ request.require_cooking ? "Yes" : "No" }}
        </p>
      </v-col>
      <v-col
        cols="4"
        v-show="request.require_cooking"
      >
        <p>
          <b>Expect Kind of Food from:</b>
          {{ request.cooking_type }}
        </p>
      </v-col>
      <v-col
        cols="4"
        v-show="request.any_kid"
      >
        <p>
          <b>Having Kids:</b>
          {{ request.amount_kid }}
        </p>
      </v-col>
      <v-col
        cols="4"
        v-show="request.any_kid"
      >
        <p>
          <b>Kids Ages:</b>
        </p>
        <p>Year: {{ request.age_year }}</p>
        <p>Month: {{ request.age_month }}</p>
      </v-col>
      <v-col
        cols="4"
        v-show="request.any_pet"
      >
        <p>
          <b>Having Pets:</b>
          {{ request.amount_pet }}
        </p>
      </v-col>
      <v-col
        cols="4"
        v-show="request.any_pet"
      >
        <p>
          <b>Type of Pet:</b>
        </p>
        <p
          v-for="(item, i) in request.type_of_pet"
          :key="i"
        >
          {{ item }}
        </p>
      </v-col>
      <v-col cols="4">
        <p>
          <b>Currently hiring helper:</b>
          {{ request.amount_current_helper }}
        </p>
      </v-col>
      <v-col cols="4">
        <p>
          <b>Special Requirement:</b>
          {{ request.special_requirement }}
        </p>
      </v-col>
    </v-row>
    <v-row
      v-show="request.request_type == 'driver'"
    >
      <v-col cols="4">
        <p>
          <b>Employer Nationality:</b>
          {{ request.employer_nationality }}
        </p>
      </v-col>
      <v-col cols="4">
        <p>
          <b>Driving Area:</b>
          {{ request.driving_area }}
        </p>
      </v-col>
      <v-col cols="4">
        <p>
          <b>Own a Car:</b>
          {{ request.has_car ? 'Yes' : 'No' }}
        </p>
      </v-col>
      <v-col
        cols="4"
        v-show="request.has_car"
      >
        <p>
          <b>Type of Car Customer Own:</b>
        </p>
        <p
          v-for="(item, i) in request.car_type"
          :key="i"
        >
          {{ item }}
          <span
            v-show="request.car_type.includes('Other')"
          >
            ({{ request.car_type_other }})
          </span>
        </p>
        <p>
          (
          <span
            v-for="(item, i) in request.car_gear_type"
            :key="i"
          >
            {{ item }},
          </span>
          )
        </p>
      </v-col>
      <v-col cols="4">
        <p>
          <b>Expected Language:</b>
        </p>
        <p
          v-for="(item, i) in request.expect_language"
          :key="i"
        >
          {{ item }}
        </p>
      </v-col>
      <v-col cols="4">
        <p>
          <b>Prefered Driver's age:</b>
        </p>
        <p
          v-for="(item, i) in request.prefer_age_range"
          :key="i"
        >
          {{ item }}
        </p>
      </v-col>
      <v-col cols="4">
        <p>
          <b>Work Day:</b>
        </p>
        <p
          v-for="(item, i) in request.work_day"
          :key="i"
        >
          {{ item }}
        </p>
      </v-col>
      <v-col cols="4">
        <p>
          <b>Work Time:</b>
          {{ request.work_time }}
        </p>
      </v-col>
      <v-col cols="4">
        <p>
          <b>Currently Hired Any Driver:</b>
          {{ request.any_driver ? 'Yes' : 'No' }}
        </p>
      </v-col>
      <v-col cols="4">
        <p>
          <b>Expected Salary for Candidate:</b>
        </p>
        <p
          v-for="(item, i) in request.expect_salary"
          :key="i"
        >
          {{ item }}
        </p>
      </v-col>
      <v-col cols="4">
        <p>
          <b>Offer Over-Time for driver:</b>
          {{ request.is_ot ? 'Yes' : 'No' }}
        </p>
      </v-col>
      <v-col cols="4">
        <p>
          <b>Start Hiring:</b>
          {{ request.start_hiring }}
        </p>
      </v-col>
      <v-col cols="4">
        <p>
          <b>Interview Preference:</b>
          {{ request.interview_channel }}
        </p>
      </v-col>
      <v-col cols="4">
        <p>
          <b>Replacement Guarantee:</b>
        </p>
        <p>
          {{ request.replacement_guarantee }}
        </p>
      </v-col>
    </v-row>
    <hr>
    <!-- end job detail -->
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'PrintArea',
  props: ['request'],
  computed: {
    issue_date () {
      return moment(String(this.request.createdAt)).format('DD MMMM, YYYY hh:mm:ss a')
    }
  }
}
</script>

<style scoped>
@media print {
  .print-area h3, .print-area p {
    margin-bottom: 8px;
  }
  .print-area table td {
    vertical-align: top;
  }
}
</style>
